import { render, staticRenderFns } from "./ProductAddOrEditContent.vue?vue&type=template&id=a1272da8&scoped=true"
import script from "./ProductAddOrEditContent.vue?vue&type=script&lang=js"
export * from "./ProductAddOrEditContent.vue?vue&type=script&lang=js"
import style0 from "./ProductAddOrEditContent.vue?vue&type=style&index=0&id=a1272da8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1272da8",
  null
  
)

export default component.exports